import { CircularProgress } from '@mui/material';
import React, { ReactNode } from 'react';
import { toast } from 'react-toastify';

interface ButtonProps {
  onButtonClick: (e: any) => void;
  children?: ReactNode;
  style?: 'primary' | 'outline' | 'secondary' | 'alert';
  //Disable button acion
  disableButton?: boolean;
  //If button is disabled show message when clicked
  showToastInstedAction?: string;
  className?: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  nextButton?: boolean;
  backButton?: boolean;
  isFunctionLoading?: boolean;
  roundedValue?: string;
}

const ButtonDesigned: React.FC<ButtonProps> = ({
  style = 'primary',
  type = 'button',
  className,
  children,
  disableButton = false,
  showToastInstedAction: showToastInstedActoion,
  onButtonClick,
  nextButton = false,
  backButton = false,
  isFunctionLoading = false,
  roundedValue = '',
}) => {
  // Set Color Sceheme Of Button
  let primaryColor = 'purple';
  let secondaryColor = 'white';

  switch (style) {
    case 'primary':
      primaryColor = 'purple';
      secondaryColor = 'white';
      break;
    case 'outline':
      primaryColor = 'white';
      secondaryColor = 'blue-600';
      break;
    case 'secondary':
      primaryColor = 'gray-700';
      secondaryColor = 'white';
      break;
    case 'alert':
      primaryColor = 'white';
      secondaryColor = 'red';
      break;
    default:
      primaryColor = 'purple';
      secondaryColor = 'white';
  }

  const buttonDisabledToast = () => {
    toast.info(showToastInstedActoion);
  };

  return (
    <button
      disabled={disableButton && !showToastInstedActoion}
      onClick={disableButton ? buttonDisabledToast : onButtonClick}
      className={`cursor-pointer border-${secondaryColor} text-${secondaryColor} bg-${primaryColor} type-${type} ${
        disableButton && 'opacity-50'
      }  text-sm border-1  py-[0.3rem] hover:brightness-95 px-[0.625rem] rounded${
        roundedValue && '-' + roundedValue
      } ${className}`}
    >
      {nextButton && <NextButtonDiv />}
      {backButton && <BackButtonDiv />}
      {isFunctionLoading && (
        <CircularProgress size={12} className={`text-${secondaryColor} align-middle  justify-center me-2`} />
      )}
      {children}
    </button>
  );
};

export default ButtonDesigned;

const NextButtonDiv = () => {
  return (
    <div className="flex">
      Next
      <img className="w-[1.2rem] " title="next" src="/assets/icons/flat/chevron-right_purple.svg"></img>
    </div>
  );
};

const BackButtonDiv = () => {
  return (
    <div className="flex">
      <img className="w-[1.2rem] rotate-180" title="next" src="/assets/icons/flat/chevron-right_purple.svg"></img>
      Back
    </div>
  );
};
